<template>
  <div class="layout">
    <!-- <van-nav-bar left-text="" left-arrow @click-left="onClickLeft" /> -->
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.layout {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  // .layout-top {
  //   height: 100%;
  // }
}
</style>
